export default "__VITE_ASSET__BVeVhRBT__"